import { AxiosError } from 'axios';
import { useState } from 'react';
import {
  ErrorHttpResponse,
  HttpConfig,
  PaginatedResponse,
} from '../models/https';
import useHttps from './useHttps';

interface JobsFilter {
  keyword?: string;
  location?: string;
  payInterval?: string;
}

const useGetGuestJobs = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [jobs, setJobs] = useState([]);

  const onGetGuestJobsError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while fetching guest jobs'
    );
  };

  const getGuestJobs = (filter?: JobsFilter) => {
    // Always limit to first page, 5 jobs only
    const page = 1;
    const perPage = 5;

    let urlPath = `jobs-service/jobs/?isFilled=false&limit=${perPage}&offset=${page}`;

    if (filter?.keyword) {
      urlPath += `&keyword=${encodeURIComponent(filter.keyword)}`;
    }
    if (filter?.location) {
      urlPath += `&location=${encodeURIComponent(filter.location)}`;
    }
    if (filter?.payInterval) {
      urlPath += `&payInterval=${encodeURIComponent(filter.payInterval)}`;
    }

    const url: HttpConfig = {
      url: urlPath,
      method: 'get',
    };

    const onGetGuestJobsSuccess = (response: PaginatedResponse) => {
      console.log('Guest jobs received:', response);
      const { content } = response;

      // Only keep up to 5 jobs
      const limitedJobs = content.slice(0, 3);
      setJobs(limitedJobs);
    };

    return request(url, onGetGuestJobsSuccess, setLoading, onGetGuestJobsError);
  };

  return { getGuestJobs, jobs, loading };
};

export default useGetGuestJobs;
